import { Component, HostBinding, Input } from '@angular/core';
import * as moment from 'moment-timezone';

import { LOCAL_TZ } from '../../globals';
import { Metar } from '../models/metar.model';
import { convert, METERS, NAUTICAL_MILES, CELSIUS, FAHRENHEIT } from '../../util/units';
import { LatLon } from '../../util/geodesy/latlon';
import { getIntercardinalDirection } from '../../util/geodesy/helpers';
import { isNumeric } from '../../util/helpers';
import { LOCAL_TIME_FMT } from '../../util/datetime-utils';


@Component({
  selector: 'app-metar',
  templateUrl: './metar.component.html',
  styleUrls: ['./metar.component.scss'],
  preserveWhitespaces: true
})
export class MetarComponent {
  private _referencePoint: LatLon;
  distance: number|null = null;
  direction: string = null;
  CELSIUS = CELSIUS;
  FAHRENHEIT = FAHRENHEIT;

  /**
   * METAR to display
   */
  @Input() metar: Metar;

  /**
   * Whether to display the METAR in translated mode
   */
  @Input()
  @HostBinding('class.wx--translated')
  translated = true;

  @HostBinding('class.wx--raw')
  get raw(): boolean {
    return !this.translated;
  }

  /**
   * Reference lat/lon. If provided, the distance and bearing from the reference point will be shown in the header
   * (e.g., "25 nm NW").
   */
  @Input() set referencePoint(point: LatLon) {
    this._referencePoint = point;
    this.distance = null;
    this.direction = null;
    if (point) {
      const result = point.vincentyInverse(this.metar.location);
      if (result && !isNaN(result.distance)) {
        this.distance = convert(result.distance, METERS, NAUTICAL_MILES);
        this.direction = getIntercardinalDirection(result.initialBearing);
      }
    }
  }

  get issueTimeLocal(): string {
    return moment(this.metar.observationTime).tz(LOCAL_TZ).format(LOCAL_TIME_FMT);
  }

  isNumeric(value: any): boolean {
    return isNumeric(value);
  }
}
